// extracted by mini-css-extract-plugin
export default {"loading":"activityList_loading__IH8Hb","pcWrap":"activityList_pcWrap__vsjnM"};